exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-log-dialog-content {\n  padding: 20px; }\n\n.user-log-dialog-content h4 {\n  font-size: 1.3rem;\n  margin: 0;\n  padding-bottom: 15px;\n  border-bottom: none; }\n\n.loading-circle {\n  position: absolute !important;\n  top: 6px !important;\n  left: 30px !important; }\n\n::ng-deep .loading-circle circle {\n  stroke: #fff !important; }\n\ninput {\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n  overflow: scroll !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/user-logs/user-logs-dialog/user-logs-dialog.component.scss
// module id = ../../../../../src/app/shared/components/user-logs/user-logs-dialog/user-logs-dialog.component.scss
// module chunks = main